import React, { useState, useEffect, useRef } from "react";
import styled from "styled-components";
import { Link } from "react-router-dom";
import Tooltip from "@mui/material/Tooltip";
import { useAuth } from "../../Auth";
import api from "../../services/api"; 

// Import Swiper React components
import { Swiper, SwiperSlide } from "swiper/react";

// Import Swiper styles
import "swiper/css";
import "swiper/css/grid";
import "swiper/css/pagination";

// import required modules
import { Grid, Keyboard, Pagination } from "swiper/modules";

import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import comp from "../../assets/images/icn-comp.png";
import pin from "../../assets/images/icn-pin.png";
import arrow from "../../assets/images/icn-arrow-r-w.png";
import check from "../../assets/images/icn-check-w.png";

const EventsElement = styled.section`
  display: flex;
  justify-content: center;
  padding: 57px 20px 52px 20px;
  background: #f1f1f1;
  overflow-x: hidden;

  .cmp-events-container {
    max-width: 1280px;
    width: 100%;
  }

  .cmp-events-header {
    display: flex;
    align-items: center;
    margin-bottom: 25px;
    flex-wrap: wrap;

    @media (max-width: 815px) {
      flex-direction: column;
      align-items: flex-start;
    }

    h2 {
      font-size: 24px;
      font-weight: 700;
      line-height: 28px;
      letter-spacing: -0.48px;
      color: #333333;
      margin-right: 40px;

      @media (max-width: 815px) {
        margin-right: unset;
        margin-bottom: 20px;
      }
    }

    ul.cmp-events-tabs {
      display: flex;

      @media (max-width: 815px) {
        order: 3;
        margin-bottom: 10px;
      }

      li {
        &:not(:last-child) {
          margin-right: 53px;

          @media (max-width: 860px) {
            margin-right: 32px;
          }
        }

        button {
          background: none;
          border: none;
          font-size: 18px;
          font-weight: 700;
          line-height: 21px;
          letter-spacing: -0.36px;
          color: #6a6d75;
          padding: 0;

          span {
            color: #2D66AC;
          }

          &:hover {
            color: #303440;
            cursor: pointer;
          }

          &.active {
            color: #303440;
            position: relative;

            &::after {
              content: " ";
              position: absolute;
              height: 3px;
              left: 0;
              right: 0;
              bottom: -10px;
              background: #2D66AC;
            }
          }
        }
      }
    }

    a {
      margin-left: auto;
      border-radius: 30px;
      background: #2D66AC;
      border: 2px solid #2D66AC;
      text-decoration: none;
      color: #fff;
      font-size: 14px;
      font-weight: 800;
      line-height: 22px;
      letter-spacing: 0;
      padding: 4px 24px;

      @media (max-width: 815px) {
        order: 2;
        margin-left: unset;
        margin-bottom: 30px;
      }
    }
  }

  .cmp-events-feed {
    @media (max-width: 520px) {
      display: none;
    }

    .swiper {
      overflow: visible;
      padding-bottom: 50px;

      .swiper-pagination {
        bottom: 0px;

        .swiper-pagination-bullet {
          height: 15px;
          width: 15px;
          background: none;
          border: 2px solid #878990;
          opacity: 1;

          &:not(:last-of-type) {
            margin-right: 10px;
          }

          &.swiper-pagination-bullet-active {
            background: #E2680E;
            border: 2px solid #E2680E;
          }
        }
      }
    }

    .swiper-slide {
      width: 375px;
      
      @media (max-width: 400px) {
        width: 100%;
        max-width: 375px;
      }
    }
  }

  .cmp-events-feed-mobile {
    @media (min-width: 521px) {
      display: none;
    }

    .cmp-events-card {
      margin-left: auto;
      margin-right: auto;
    }

    .swiper {
      padding-bottom: 50px;

      .swiper-pagination {
        bottom: 0px;

        .swiper-pagination-bullet {
          height: 15px;
          width: 15px;
          background: none;
          border: 2px solid #878990;
          opacity: 1;

          &:not(:last-of-type) {
            margin-right: 10px;
          }

          &.swiper-pagination-bullet-active {
            background: #E2680E;
            border: 2px solid #E2680E;
          }
        }
      }
    }
  }

  .cmp-events-card {
    background-size: cover;
    background-color: #303440;
    width: 375px;
    border-radius: 12px;
    height: 195px;
    position: relative;
    padding: 16px 20px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    box-sizing: border-box;

    @media (max-width: 400px) {
      width: 100%;
      max-width: 375px;
      height: 220px;
      padding: 14px 18px;
    }
   
    
    &::before {
      border-radius: 12px;
      content: " ";
      position: absolute;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      background: rgb(36, 39, 49);
      background: linear-gradient(
        90deg,
        rgba(36, 39, 49, 0.9) 0%,
        rgb(130 130 133 / 40%) 100%
      );
      opacity: 0.9;
      z-index: 1;
    }

    .cmp-events-card-header,
    .cmp-events-card-footer {
      z-index: 2;
      position: relative;
    }

    .cmp-events-card-header {
      .cmp-event-card-date,
      .cmp-event-card-location {
        font-size: 14px;
        line-height: 16px;
        letter-spacing: 0;
        color: #fff;
      }

      .cmp-event-card-title {
        font-size: 20px;
        line-height: 22px;
        letter-spacing: 0;
        font-weight: 700;
        color: #fff;
        margin: 3px 0;
        
        @media (max-width: 400px) {
          font-size: 18px;
          line-height: 20px;
          margin: 2px 0;
        }
      }
      a.cmp-event-card-button {
        font: Roboto;
        font-weight: 500;
        font-size: 12px;
        line-height: 12px;
        padding: 8px;
        border-radius: 6px;
        background-color: #E2680E;
        margin-bottom: 14px;
        width:90px;
        text-transform: uppercase;
        text-align:center!important;
        display:block!important;
        &:hover {
          background: transparent;
          color: #fff;
        }

        &.register {
          background: #E2680E;
          color: #fff;
          display: flex;
          align-items: center;
          border: 2px solid #E2680E;

          img {
            width: 16px;
            height: 18px;
            margin-right: 6px;
          }
        }
      }
    }

    .cmp-events-card-footer {
      display: flex;
      align-items: center;

      .cmp-event-card-type-icon {
        margin-right: 20px;

        img {
          height: 22px;
          width: auto;
        }
      }

      a.cmp-event-card-button {
        background: #ffffff;
        border: 2px solid #fff;
        font-size: 16px;
        line-height: 22px;
        font-weight: 700;
        text-decoration: none;
        color: #303440;
        border-radius: 30px;
        padding: 3px 21px;

        &:hover {
          background: transparent;
          color: #fff;
        }

        &.register {
          background: #E2680E;
          color: #fff;
          display: flex;
          align-items: center;
          border: 2px solid #E2680E;

          img {
            width: 16px;
            height: 18px;
            margin-right: 6px;
          }
        }
      }

      a.cmp-event-card-more-info {
        margin-left: auto;
        display: flex;
        align-items: center;
        text-transform: uppercase;
        text-decoration: none;
        color: #fff;
        font-size: 14px;
        line-height: 16px;
        font-weight: 900;

        img {
          height: 16px;
          width: 16px;
          margin-left: 10px;
        }
      }
    }
  }

  .cmp-event-feed-empty {
    padding: 40px 0 20px 0;
  }

  .cmp-debug-btn {
    border-radius: 30px;
    background: #E2680E;
    border: 2px solid #E2680E;
    -webkit-text-decoration: none;
    text-decoration: none;
    color: #fff;
    font-size: 14px;
    font-weight: 500;
    line-height: 22px;
    -webkit-letter-spacing: 0;
    -moz-letter-spacing: 0;
    -ms-letter-spacing: 0;
    letter-spacing: 0;
    padding: 4px 24px;
    margin-top: 10px;
  }

  .loading-container {
    display: flex;

    .loading-card {
      height: 240px;
      width: 100%;
      background: #fff;
      border-radius: 7px;
      padding: 26px 24px 21px;
      display: flex;
      flex-direction: column;

      &:not(:last-child) {
        margin-right: 20px;
      }

      .loading-card-footer {
        margin-top: auto;
        display: flex;

        div {
          &:nth-child(1) {
            width: 12%;
            margin-right: 26px;
          }

          &:nth-child(2) {
            width: 35%;
          }
        }
      }
    }
  }
`;

const Events = () => {

  const [activeTab, setActiveTab] = useState("membership");
  const [loading, setLoading] = useState(true);
  const [eventData, setEventData] = useState(null);
  const [events, setEvents] = useState(null);

  const { cmpData, environment, cuesURL, cmanURL, canSectionLoad, markSectionLoaded } = useAuth();

  function handleGAEvent(eventTitle, value) {
    if (cmpData) {
      // if (window.location.host == "mycues.cues.org") {
        // Push event to GTM data layer
        if (window.dataLayer) {
          window.dataLayer.push({
            event: eventTitle,
            event_category: 'Events',
            event_label: value,
            value: value,
            user_role: cmpData.account_info.acgiRole,
            user_memberlevel: cmpData.account_info.membershipLevel,
            user_company: cmpData.account_info.employer,
          });
        }
      // }
    }
  }

  useEffect(() => {
    if (cmpData && canSectionLoad('cmp_events') && !eventData) {
      const eventsApiUrl = cuesURL + "/cmp/events";
      
      api.get(eventsApiUrl)
        .then(function (response) {
          // Normalize the response structure
          let normalizedData = response.data;
          
          // If the response is an array directly, wrap it in the expected structure
          if (Array.isArray(response.data)) {
            normalizedData = {
              events: {
                withMembership: response.data,
                purchase: [],
                registered: []
              }
            };
          } else if (response.data && !response.data.events) {
            // If response.data exists but doesn't have events property, wrap it
            normalizedData = {
              events: {
                withMembership: [],
                purchase: [],
                registered: []
              }
            };
          }
          
          setEventData(normalizedData);
          setLoading(false);
          markSectionLoaded('cmp_events');
        })
        .catch(function (error) {
          setLoading(false);
          markSectionLoaded('cmp_events'); // Mark as loaded even on error to unblock next section
        });
    }
  }, [cmpData, canSectionLoad, cuesURL, eventData, markSectionLoaded]);

  useEffect(() => {
    if (!loading && eventData) {
      // Ensure events structure exists
      const eventsData = eventData.events || {
        withMembership: [],
        purchase: [],
        registered: []
      };
      
      switch (activeTab) {
        case "membership":
          const membershipEvents = eventsData.withMembership || [];
          setEvents(membershipEvents);
          break;
        case "purchase":
          const purchaseEvents = eventsData.purchase || [];
          setEvents(purchaseEvents);
          break;
        case "registered":
          const registeredEvents = eventsData.registered || [];
          setEvents(registeredEvents);
          break;
        default:
          setEvents([]);
      }
    } else if (!loading && !eventData) {
      // If no event data, set empty array
      setEvents([]);
    }
  }, [loading, activeTab, eventData]);

  return (
    <>
      {loading && (
        <EventsElement>
          <div className="cmp-events-container">
            {/* Header */}
            <div className="cmp-events-header">
              <h2>Events</h2>
            </div>

            <div className="loading-container">
              <div className="loading-card">
                <div className="loading-card-header">
                  <Skeleton count={2} height={24} />
                </div>

                <div className="loading-card-footer">
                  <div>
                    <Skeleton count={1} height={24} />
                  </div>
                  <div>
                    <Skeleton count={1} height={24} />
                  </div>
                </div>
              </div>

              <div className="loading-card">
                <div className="loading-card-header">
                  <Skeleton count={2} height={24} />
                </div>

                <div className="loading-card-footer">
                  <div>
                    <Skeleton count={1} height={24} />
                  </div>
                  <div>
                    <Skeleton count={1} height={24} />
                  </div>
                </div>
              </div>

              <div className="loading-card">
                <div className="loading-card-header">
                  <Skeleton count={2} height={24} />
                </div>

                <div className="loading-card-footer">
                  <div>
                    <Skeleton count={1} height={24} />
                  </div>
                  <div>
                    <Skeleton count={1} height={24} />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </EventsElement>
      )}

      {!loading && eventData && events && (
        <EventsElement>
          <div className="cmp-events-container">
            {/* Header */}
            <div className="cmp-events-header">
              <h2>Events</h2>
              <ul className="cmp-events-tabs">
                <li>
                  <button
                    className={activeTab == "membership" ? "active" : ""}
                    onClick={() => {
                      setActiveTab("membership");
                    }}
                  >
                    Included with Membership
                  </button>
                </li>
                <li>
                  <button
                    className={activeTab == "purchase" ? "active" : ""}
                    onClick={() => {
                      setActiveTab("purchase");
                    }}
                  >
                    For Purchase
                  </button>
                </li>
                <li>
                  <button
                    className={activeTab == "registered" ? "active" : ""}
                    onClick={() => {
                      setActiveTab("registered");
                    }}
                  >
                    {/* Display the number of events the user has registered for. */}
                    Registered{" "}
                    <span>({eventData.events.registered.length})</span>
                  </button>
                </li>
              </ul>

              <a
                href={
                  "https://www.cues.org/professional-development-and-events"
                }
                target="_blank"
                rel="noopener noreferrer"
                className="cmp-events-view-all-link"
                onClick={() => {
                  handleGAEvent("events_viewall");
                }}
              >
                VIEW ALL EVENTS
              </a>
            </div>

            {/* Feed */}
            <div className="cmp-events-feed">
              {eventData && events && Object.values(events).length > 0 ? (
                <Swiper
                  simulateTouch={true}
                  slidesPerView={"auto"}
                  slidesPerGroup={3}
                  spaceBetween={30}
                  keyboard={{
                    enabled: true,
                  }}
                  pagination={{
                   type:'none'
                  }}
                  modules={[Pagination, Keyboard]}
                  className="mySwiper"
                >
                  <>
                    {Object.values(events).map((event, index) => (
                      <SwiperSlide key={event.eventId || event.title || `event-${index}`}>
                        <div
                          className="cmp-events-card"
                          data-event-id={event.eventId}
                          data-event-node-id={event.eventNodeId}
                          style={{
                            backgroundImage: event.image
                              ? `url("${event.image.startsWith('https://') ? event.image : `https://cues.org${event.image}`}")`
                              : `none`,
                          }}
                        >
                         
                          <div className="cmp-events-card-header">
                          {(activeTab == "registered" && (event.eventDestinationUrl === null ||
                                event.eventDestinationUrl === undefined))&& (
                              <a
                                className={`cmp-event-card-button register${
                                  event.eventDestinationUrl ? "" : " no-link"
                                }`}
                                href={event.eventDestinationUrl}
                                target={
                                  event.eventDestinationUrl ? "_blank" : ""
                                }
                              >
                              {event.eventDestinationUrl === null ||
                                event.eventDestinationUrl === undefined
                                  ? " Registered"
                                  : " Access Now"}
                              </a>
                            )}
                            {event.eventDetailsLink ? (
                              <a
                                href={
                                  activeTab == "registered"
                                    ? cuesURL + event.eventDetailsLink
                                    : event.eventDetailsLink
                                }
                                target="_blank"
                                rel="noreferrer"
                                className="cmp-event-card-header-link"
                                onClick={() => {
                                  if (activeTab == "registered") {
                                    handleGAEvent(
                                      "events_currently_registered",
                                      event.eventDetailsLink
                                    );
                                  } else {
                                    handleGAEvent(
                                      "events_moreinfo",
                                      event.eventDetailsLink
                                    );
                                  }
                                }}
                              >
                                <p className="cmp-event-card-date">{event.date}</p>
                                <p className="cmp-event-card-title">
                                  {event.title}
                                </p>

                                {event.eventLocation && (
                                  <p className="cmp-event-card-location">
                                    {event.eventLocation}
                                  </p>
                                )}
                              </a>
                            ) : (
                              <>
                                <p className="cmp-event-card-date">{event.date}</p>
                                <p className="cmp-event-card-title">
                                  {event.title}
                                </p>

                                {event.eventLocation && (
                                  <p className="cmp-event-card-location">
                                    {event.eventLocation}
                                  </p>
                                )}
                              </>
                            )}
                          </div>

                          <div className="cmp-events-card-footer">
                            <div className="cmp-event-card-type-icon">
                              {event.eventType !== "Online Event" ? (
                                <img src={pin} alt="Online Event" />
                              ) : (
                                <img src={comp} alt="In-Person Event" />
                              )}
                            </div>

                            {/* Show registered button for registered events, or show register button for non-registered events */}

                            {event.registrationLink && (
                              <a
                                href={event.registrationLink}
                                className="cmp-event-card-button cmp-event-card-button--register"
                                onClick={() => {
                                  handleGAEvent(
                                    "events_register_click",
                                    event.registrationLink
                                  );
                                }}
                              >
                                REGISTER
                              </a>
                            )}

                            {(activeTab == "registered" && event.eventDestinationUrl !== null) && (
                              <a
                                className={`cmp-event-card-button register${
                                  event.eventDestinationUrl ? "" : " no-link"
                                }`}
                                href={event.eventDestinationUrl}
                                target={
                                  event.eventDestinationUrl ? "_blank" : ""
                                }
                              >
                                {(event.eventDestinationUrl === null ||
                                  event.eventDestinationUrl === undefined) && (
                                  <img src={check} />
                                )}{" "}
                                {event.eventDestinationUrl === null ||
                                event.eventDestinationUrl === undefined
                                  ? "Registered"
                                  : " Access Now"}
                              </a>
                            )}

                            {event.eventDetailsLink && (
                              <>
                                <a
                                  href={
                                    activeTab == "registered"
                                      ? cuesURL + event.eventDetailsLink
                                      : event.eventDetailsLink
                                  }
                                  target="_blank"
                                  rel="noopener noreferrer"
                                  className="cmp-event-card-more-info"
                                  onClick={() => {
                                    if (activeTab == "registered") {
                                      handleGAEvent(
                                        "events_currently_registered",
                                        event.eventDetailsLink
                                      );
                                    } else {
                                      handleGAEvent(
                                        "events_moreinfo",
                                        event.eventDetailsLink
                                      );
                                    }
                                  }}
                                >
                                  More Info <img src={arrow} />
                                </a>
                              </>
                            )}
                          </div>
                        </div>
                      </SwiperSlide>
                    ))}
                  </>
                </Swiper>
              ) : (
                <div className="cmp-event-feed-empty">
                  {activeTab == "registered" && (
                     <>
                    <div className="cmp-events-card empty">
                      <div className="cmp-events-card-header">
                        <div className="cmp-event-card-title">
                          You're not currently registered in any events. Don't miss out! Take a look at all of our upcoming events.
                        </div>
                        </div>
                        <div className="cmp-events-card-footer">
                        <a
                                href={
                                  "https://www.cues.org/professional-development-and-events"
                                }
                                target="_blank"
                                rel="noopener noreferrer"
                                className="cmp-event-card-button cmp-event-card-button--register"
                                onClick={() => {
                                  handleGAEvent("events_viewall");
                                }}
                              >
                                EXPLORE NOW
                              </a>
                        {/* )} */}
                        </div>
                      
                      </div>
                   </>
                    // <>
                    //   <p>
                    //     <em>
                    //       Looks like you don't have any events planned; they
                    //       will appear here as you register for them.
                    //     </em>
                    //   </p>
                    // </>
                  )}

                  {activeTab == "membership" && (
                    <>
                      <p>
                        <em>
                          Looks like there are no membership events for you
                          currently, but be sure to check back later—we're
                          always adding new ones!
                        </em>
                      </p>
                    </>
                  )}

                  {activeTab == "purchase" && (
                    <>
                     <div className="cmp-events-card empty">
                      <div className="cmp-events-card-header">
                        <div className="cmp-event-card-title">
                        Looks like there are no recommended events for you
                          currently, but be sure to check back later–we’re
                          always adding new ones!
                        </div>
                        </div>
                        <div className="cmp-events-card-footer">
                        {/* <a
                                href={
                                  "https://www.cues.org/professional-development-and-events"
                                }
                                target="_blank"
                                className="cmp-event-card-button cmp-event-card-button--register"
                                onClick={() => {
                                  handleGAEvent("events_viewall");
                                }}
                              >
                                Explore Events
                              </a> */}
                        {/* )} */}
                        </div>
                      
                      </div>
                      {/* <p>
                        <em>
                          Looks like there are no recommended events for you
                          currently, but be sure to check back later–we’re
                          always adding new ones!
                        </em>
                      </p> */}
                    </>
                  )}
                </div>
              )}
            </div>

            {/* Mobile Feed */}
            <div className="cmp-events-feed-mobile">
              {eventData && events && Object.values(events).length > 0 ? (
                <Swiper
                  slidesPerView={1}
                  spaceBetween={30}
                  pagination={{
                    clickable: true,
                  }}
                  modules={[Grid, Pagination]}
                  className="mySwiper"
                >
                  <>
                    {Object.values(events).map((event, index) => (
                      <SwiperSlide key={event.eventId || event.title || `event-mobile-${index}`}>
                        <div
                          className="cmp-events-card"
                          data-event-id={event.eventId}
                          data-event-node-id={event.eventNodeId}
                          style={{
                            backgroundImage: event.image
                              ? `url("${event.image.startsWith('https://') ? event.image : `https://cues.org${event.image}`}")`
                              : `none`,
                          }}
                        >
                          <div className="cmp-events-card-header">
                            {event.eventDetailsLink ? (
                              <a
                                href={
                                  activeTab == "registered"
                                    ? cuesURL + event.eventDetailsLink
                                    : event.eventDetailsLink
                                }
                                target="_blank"
                                rel="noreferrer"
                                className="cmp-event-card-header-link"
                                onClick={() => {
                                  if (activeTab == "registered") {
                                    handleGAEvent(
                                      "events_currently_registered",
                                      event.eventDetailsLink
                                    );
                                  } else {
                                    handleGAEvent(
                                      "events_moreinfo",
                                      event.eventDetailsLink
                                    );
                                  }
                                }}
                              >
                                <p className="cmp-event-card-date">{event.date}</p>
                                <p className="cmp-event-card-title">
                                  {event.title}
                                </p>

                                {event.eventLocation && (
                                  <p className="cmp-event-card-location">
                                    {event.eventLocation}
                                  </p>
                                )}
                              </a>
                            ) : (
                              <>
                                <p className="cmp-event-card-date">{event.date}</p>
                                <p className="cmp-event-card-title">
                                  {event.title}
                                </p>

                                {event.eventLocation && (
                                  <p className="cmp-event-card-location">
                                    {event.eventLocation}
                                  </p>
                                )}
                              </>
                            )}
                          </div>

                          <div className="cmp-events-card-footer">
                            <div className="cmp-event-card-type-icon">
                              {event.eventType !== "Online Event" ? (
                                <img src={pin} alt="Online Event" />
                              ) : (
                                <img src={comp} alt="In-Person Event" />
                              )}
                            </div>

                            {/* Show registered button for registered events, or show register button for non-registered events */}

                            {event.registrationLink && (
                              <a
                                href={event.registrationLink}
                                className="cmp-event-card-button"
                                onClick={() => {
                                  handleGAEvent(
                                    "events_register_click",
                                    event.registrationLink
                                  );
                                }}
                              >
                                Register
                              </a>
                            )}

                            {activeTab == "registered" && (
                              <a
                                className={`cmp-event-card-button register${
                                  event.eventDestinationUrl ? "" : " no-link"
                                }`}
                                href={event.eventDestinationUrl}
                                target={
                                  event.eventDestinationUrl ? "_blank" : ""
                                }
                              >
                                {(event.eventDestinationUrl === null ||
                                  event.eventDestinationUrl === undefined) && (
                                  <img src={check} />
                                )}
                                {event.eventDestinationUrl === null ||
                                event.eventDestinationUrl === undefined
                                  ? "Registered"
                                  : " Access Now"}
                              </a>
                            )}

                            {event.eventDetailsLink && (
                              <a
                                href={event.eventDetailsLink}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="cmp-event-card-more-info"
                                onClick={() => {
                                  if (activeTab == "registered") {
                                    handleGAEvent(
                                      "events_currently_registered",
                                      event.eventDetailsLink
                                    );
                                  } else {
                                    handleGAEvent(
                                      "events_moreinfo",
                                      event.eventDetailsLink
                                    );
                                  }
                                }}
                              >
                                More Info <img src={arrow} />
                              </a>
                            )}
                          </div>
                        </div>
                      </SwiperSlide>
                    ))}
                  </>
                </Swiper>
              ) : (
                <div className="cmp-event-feed-empty">
                  {activeTab == "registered" && (
                    <>
                      <p>
                        <em>
                          Looks like you don't have any events planned; they
                          will appear here as you register for them.
                        </em>
                      </p>
                    </>
                  )}

                  {activeTab == "membership" && (
                    <>
                      <p>
                        <em>
                          Looks like there are no membership events for you
                          currently, but be sure to check back later—we're
                          always adding new ones!
                        </em>
                      </p>
                    </>
                  )}

                  {activeTab == "purchase" && (
                    <>
                      <p>
                        <em>
                          Looks like there are no recommended events for you
                          currently, but be sure to check back later–we’re
                          always adding new ones!
                        </em>
                      </p>
                    </>
                  )}
                </div>
              )}
            </div>
          </div>
        </EventsElement>
      )}
    </>
  );
};

export default Events;
